import { render, staticRenderFns } from "./KingdomThumb.vue?vue&type=template&id=070ba455&scoped=true"
import script from "./KingdomThumb.vue?vue&type=script&lang=js"
export * from "./KingdomThumb.vue?vue&type=script&lang=js"
import style0 from "./KingdomThumb.vue?vue&type=style&index=0&id=070ba455&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070ba455",
  null
  
)

export default component.exports